handleUpdatePaymentMethod